import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, ViewChild, TemplateRef, Renderer2 } from '@angular/core';
import { Product } from '@interfaces/product';
import { UntypedFormControl, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CartService } from '@services/cart.service';
import { WishlistService } from '@services/wishlist.service';
import { CompareService } from '@services/compare.service';
import { RootService } from '@services/root.service';
import { AuthenticationService } from '@app/_services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AskVendorComponent } from '@app/shared/components/ask-vendor/ask-vendor.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { SharedService } from '@app/_services/shared.service';
import { Title } from '@angular/platform-browser';
import { ChatModalComponent } from '@app/_components/live-chat/chat-modal/chat-modal.component';
import { ChatService } from '@app/_services/chat.service';
import { Router, RouterLink } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CurrencyFormatPipe } from '../../../shared/pipes/currency-format.pipe';
import { MatIconModule } from '@angular/material/icon';
import { EventCollectorDirective } from '../../../_directives/events-collector/events.collector';
import { SocialShareButtonsComponent } from '../../share-buttons/social-share-buttons.component';
import { ProductOptionsComponent } from '../../page-product/product-options/product-options.component';
import { NgClass, NgIf } from '@angular/common';
import { ProductGalleryNewComponent } from '../../../shared/components/product-gallery-new/product-gallery-new.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BookingTabsComponent } from '../booking-tabs/booking-tabs.component';
import { InputNumberNewComponent } from '@app/shared/components/input-number-new/input-number-new.component';
import { ServiceDataEntry } from '@interfaces/professional-booking';


export type ProductLayout = 'standard' | 'sidebar' | 'columnar' | 'quickview';

@Component({
    selector: 'app-service-new',
    templateUrl: './service-new.component.html',
    styleUrls: ['./service-new.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [ProductGalleryNewComponent, NgIf, ProductOptionsComponent, SocialShareButtonsComponent, RouterLink, EventCollectorDirective, MatIconModule, TranslateModule, CurrencyFormatPipe,NgScrollbarModule,BookingTabsComponent,InputNumberNewComponent,FormsModule, ReactiveFormsModule, NgClass]
})
export class ServiceNewComponent {
    userDetails: any;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private cart: CartService,
        private wishlist: WishlistService,
        private compare: CompareService,
        public root: RootService,
        private fb: UntypedFormBuilder,
        private authService: AuthenticationService,
        private toastr: ToastrService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private modalService: BsModalService,
        private shareService: SharedService,
        private titleService: Title,
        private router: Router,
        private renderer: Renderer2,
        public deviceDetector: DeviceDetectorService,
        private chatService: ChatService,
    ) {
        this.sector = this.shareService.page;

        this.modalService.onHide.subscribe(() => {
            this.renderer.removeClass(document.body, 'chat-modal');
        });

        this.modalService.onShown.subscribe(() => {
            if (document.getElementsByClassName('live-chat-popup')[0]) {
                this.renderer.addClass(document.getElementsByClassName('live-chat-popup')[0].parentElement, 'live-chat');
            }

            if (this.deviceDetector.isMobile()) {
                this.renderer.addClass(document.getElementsByClassName('modal')[0], 'mobile');
            }
        });
    }
    sector;
    @Input() layout: ProductLayout;

    @Input() product: any;
    isMobile = this.deviceDetector.isMobile();

    @Input() form;
    @Input() disabledDates;
    @Input() timeslots;

    addingToCart = false;

    /**
     * Book instead of add to cart (professional services, booking plan Phase 5): when this has a subscriber the
     * page shows a Book button, hides the product-only controls, and emits the selection instead.
     */
    @Output() book = new EventEmitter<ServiceDataEntry[]>();
    /** Set by the page while a booking request is in flight. */
    @Input() booking = false;

    get bookingMode(): boolean {
        return this.book.observers.length > 0;
    }

    bsModalRef: BsModalRef;
    @ViewChild('modal', { read: TemplateRef }) template: TemplateRef<any>;
    @ViewChild(BookingTabsComponent) BookingTabsComponent!: BookingTabsComponent;

    ngOnInit(): void {
        this.userDetails = this.authService.currentUser;
    }

    openChat(): any {
        if (!this.userDetails || !this.authService.currentUserValue) {
            return this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
        }

        // create chat
        var newChat: any = {
            "companyId": this.product?.companyData?._id,
            "subject": {
                "type": "product",
                "title": {
                    "en": this.titleService.getTitle(),
                    "ar": this.titleService.getTitle(),
                },
                "url": window.location.href,
                "ObjectId": this.product?._id,
            },
            "type": 'vendor',
            "message": ""
        };

        this.chatService.createChat(newChat).subscribe((response: any) => {
            // console.log("CREATE CHAT::", response);

            this.bsModalRef = null;

            const initialState = {
                chatId: response.data?._id
            };

            this.bsModalRef = this.modalService.show(ChatModalComponent, {
                initialState,
                class: 'full-screen live-chat-popup',
                backdrop: false,
                ignoreBackdropClick: true
            });

            this.bsModalRef.content.closeBtnName = 'Close';

            this.renderer.addClass(document.body, 'chat-modal');
        });
    }

    get amount() {
        return this.form.get('amount') as UntypedFormControl;
    }


    askVendor() {
        const initialState = {
            companyId: this.product.companyId,
            product: this.product,
        };
        this.bsModalRef = this.modalService.show(AskVendorComponent, {
            initialState,
        });
        this.bsModalRef.content.closeBtnName = 'Close';
    }

      addToCart(): void {
        this.BookingTabsComponent.addToCart();
    }

    bookService(): void {
        const selection = this.BookingTabsComponent?.getSelection();
        if (selection) this.book.emit(selection);
    }

}
